import { getAssetUrl } from '../../../../../../../utils/assetUtils';

const ReportedIncident = ({ issueDescription, screenshotUrl }) => {
  return (
    <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm max-w-2xl mx-auto">
      <span className="text-[10px] font-bold text-gray-400 uppercase mb-2 block tracking-wider">
        Reported Incident
      </span>
      <p className="text-sm text-gray-700 leading-relaxed font-semibold">
        {issueDescription}
      </p>
      {screenshotUrl && (
        <a
          href={getAssetUrl(screenshotUrl)}
          target="_blank"
          rel="noreferrer"
          className="mt-4 block rounded-lg overflow-hidden border border-gray-50 hover:opacity-90 transition-all"
        >
          <img
            src={getAssetUrl(screenshotUrl)}
            className="w-full max-h-60 object-contain bg-gray-50"
            alt="Attachment"
          />
        </a>
      )}
    </div>
  );
};

export default ReportedIncident;
